// Imports
// ------
import styled, { css } from 'styled-components';
import { breakup, H2, H3, H4, H5, P } from '@tackl';
import { pStyles } from '@tackl-type';

// Exports
// ------
const sharedTitleStyles = props => css`
    transition: all 0.3s ${props.theme.bezzy};
    margin-bottom: 3.6rem;

    color: ${props.theme.white};
`;

const sharedTextStyles = props => css`
  color: ${props.theme.white};
`;

export const TitleH2 = styled(H2)` ${sharedTitleStyles} `;
export const TitleH3 = styled(H3)` ${sharedTitleStyles} `;
export const TitleH4 = styled(H4)` ${sharedTitleStyles} `;
export const TitleH5 = styled(H5)` ${sharedTitleStyles} `;

export const Text = styled(P)(
  (p) => css`
    ${sharedTextStyles}
    transition: all 0.3s ${p.theme.bezzy};
    margin-bottom: 2.4rem;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      color: inherit;
      font-weight: ${p.theme.bold};
    }

    ${p.textSmall && css`
      font-size: 1.6rem;
    `}
  `
);

export const Code = styled.code(
  (props) => css`
    ${sharedTextStyles}
    padding: .5rem 1.2rem;

    font-family: Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console",
      "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono",
      "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier,
      monospace;
  `
);

export const Pre = styled.div(
  (props) => css`
    ${sharedTextStyles}
    display: block;
    margin-bottom: 2.4rem;

    pre {
      background: ${props.theme.offwhite} !important;
      padding: 2.4rem !important;

      white-space: pre-wrap;

      code {
        counter-reset: line-numbering;
        display: block;
        background: none;
        padding: 0;

        font-family: ${props.theme.mono};
        font-size: 1.4rem;
        line-height: 1.2;

        ${breakup.medium` font-size: 1.6rem; `}

        span {
          white-space: pre-wrap;
          font-family: ${props.theme.mono};
        }
      }
    }
  `
);

export const BlockQuote = styled.blockquote`
  ${sharedTextStyles}
  position: relative;
  display: block;
  margin: 4rem 0 8rem;

  p {
    ${sharedTextStyles}
    position: relative;
    quotes: "“" "”" "‘" "’";

    ${pStyles}

    &:after {
      content: close-quote;
    }
  }
`;

export const Ul = styled.ul`
  ${sharedTextStyles}
  list-style: disc outside;
  margin-left: 2rem;
  margin-bottom: 2.4rem;

  &:last-child { margin-bottom: 0rem; }

  li {
    ${pStyles}
    ${sharedTextStyles}
  }
`;

export const Ol = styled.ol`
  ${sharedTextStyles}
  list-style: decimal outside;
  margin-left: 2rem;
  margin-bottom: 2.4rem;

  li {
    ${pStyles}
    ${sharedTextStyles}
  }
`;

export const Anchor = styled.a(p => css`
  position: relative;

  transition: all 0.3s ${p.theme.bezzy};
  color: ${p.theme.bc1};

  &:before {
    transition: all 0.3s ${p.theme.bezzy};

    content: '';
    position: absolute;
    bottom: -.1rem;

    height: 1px;
    width: 100%;
    background: ${p.theme.bc1};
  }

  &:visited {
    color: ${p.theme.bc1};
  }

  &:hover {
    color: ${p.theme.white};

    &:before {
      background: ${p.theme.white};
    }
  }
`);
